import { DrawCustomModeThis, DrawFeature, DrawLineString, DrawPoint } from "@mapbox/mapbox-gl-draw";

import { ValidationState } from "fond/draw/validation/helper";

import { deleteAndValidate, getFeatureId, getSpanPoles, pullInFeatures } from "./helper";

/**
 * Aerial delete handler.
 *
 * Deleting a pole cascades to the spans connected to it; deleting a span leaves its
 * poles in place but refreshes their snapped status.
 *
 * Designed to be used as an EditingLayer.onTrash callback.
 */
export function onTrashAerial(this: DrawCustomModeThis, features: DrawFeature[], state: ValidationState): void {
  const deleteIds: (string | number)[] = [];
  const polesToRefresh: DrawPoint[] = [];

  features.forEach((feature) => {
    if (feature.id != null) {
      deleteIds.push(feature.id);
    }

    if (feature.type === "Point") {
      const { spans } = pullInFeatures.call(this, feature);
      deleteIds.push(...spans.map((span) => getFeatureId(span)).filter((id): id is string | number => id != null));
    } else if (feature.type === "LineString") {
      polesToRefresh.push(...getSpanPoles.call(this, feature as DrawLineString));
    }
  });

  deleteAndValidate.call(this, state, deleteIds, polesToRefresh);
}
